import { TableCellNode } from "@lexical/table";
import { DOMExportOutput, EditorConfig, isHTMLElement, LexicalEditor } from "lexical";

export class ExtendedTableCellNode extends TableCellNode {
	static override getType(): string {
		return "extended-table-cell";
	}

	static override clone(node: ExtendedTableCellNode): ExtendedTableCellNode {
		return new ExtendedTableCellNode(
			node.__headerState,
			node.__colSpan,
			node.__rowSpan,
			node.__key
		);
	}

    override createDOM(config: EditorConfig): HTMLTableCellElement {
        const element = super.createDOM(config);
        element.style.width = "fit-content";
		element.style.border = "none";
        
        return element;
    }

	override exportDOM(editor: LexicalEditor): DOMExportOutput {
		const output = super.exportDOM(editor);

		if (isHTMLElement(output.element)) {
			const element = output.element as HTMLTableCellElement;
			element.setAttribute(
				"data-temporary-table-cell-lexical-key",
				this.getKey()
			);

			if (this.__colSpan > 1) {
				element.colSpan = this.__colSpan;
			}
			if (this.__rowSpan > 1) {
				element.rowSpan = this.__rowSpan;
			}

			element.style.border = "none";
            element.style.width = "fit-content";
            
			element.style.verticalAlign = this.getVerticalAlign() || "top";
			element.style.textAlign = "start";
			if (this.__backgroundColor === null && this.hasHeader()) {
				element.style.backgroundColor = "#f2f3f5";
			}
		}

		return output;
	}
}
